import { lazy } from "react";
import { Navigate } from "react-router-dom";

import AppLayout from "../presentaion/layouts/FullLayout/AppLayout";
import RequireAuth from "../Routes/RequireAuth";

import PartnersList from "../presentaion/screens/Partners/PartnersList";
import AddPartner from "../presentaion/screens/Partners/AddPartner";

/* ===== LAZY SCREENS ===== */

const Dashboard = lazy(() =>
  import("../presentaion/screens/Dashboard/Dashboard")
);

const Requests = lazy(() =>
  import("../presentaion/screens/Requests/Requests")
);

const Users = lazy(() =>
  import("../presentaion/screens/Users/Users")
);

const Events = lazy(() =>
  import("../presentaion/screens/Events/Events")
);

const PartnerProfile = lazy(() =>
  import("../presentaion/screens/Partners/PartnerProfile")
);

const AddAmbulance = lazy(() =>
  import("../presentaion/screens/Partners/AddAmbulance")
);

/* ===== PRIVATE ROUTES ===== */

const privateRoutes = [
  {
    element: (
      <RequireAuth>
        <AppLayout />
      </RequireAuth>
    ),
    children: [
      /* Default */
      { index: true, element: <Navigate to="/dashboard" replace /> },

      /* Core */
      { path: "dashboard", element: <Dashboard /> },
      { path: "requests", element: <Requests /> },
      { path: "users", element: <Users /> },
      { path: "events", element: <Events /> },

      /* ===== PARTNERS ===== */
      { path: "partners", element: <PartnersList /> },
      { path: "partners/add", element: <AddPartner /> },
      { path: "partners/:partnerId", element: <PartnerProfile /> },
      {
        path: "partners/:partnerId/ambulances/add",
        element: <AddAmbulance />,
      },

      /* Fallback */
      { path: "*", element: <Navigate to="/dashboard" replace /> },
    ],
  },
];

export default privateRoutes;
